import Component from '../Component';
import React from 'react';
import {Select} from 'reactis-inputs';
import DbInfo from '../../dbinfo';
import immutable from 'immutable';

export default class Reminders extends Component {

	handleChange(index, val) {
		const value = this.getValue();
		value[index] = val;
		this.props.onChange(immutable.List(value));
	}

	getValue() {
		let value = [null, null, null];
		if (this.props.value) {
			value[0] = this.props.value.get(0);
			value[1] = this.props.value.get(1);
			value[2] = this.props.value.get(2);
		}
		return value;
	}

	render() {
		const value = this.getValue();

		return (
			<div>
				<table>
					<tbody>
						<tr>
							<td>I.</td>
							<td>
								<Select placeholder="vyberte 1. upomínku"
										onChange={(value) => this.handleChange(0, value)}
										value={value[0]}
										clearable={true}
										options={DbInfo.ReminderSelect}
										style={{width:165}}
								/>
							</td>
							<td>II.</td>
							<td>
								<Select placeholder="vyberte 2. upomínku"
										onChange={(value) => this.handleChange(1, value)}
										value={value[1]}
										clearable={true}
										options={DbInfo.ReminderSelect}
										style={{width:165}}
								/>
							</td>
							<td>III.</td>
							<td>
								<Select placeholder="vyberte 3. upomínku"
										onChange={(value) => this.handleChange(2, value)}
										value={value[2]}
										clearable={true}
										options={DbInfo.ReminderSelect}
										style={{width:165}}
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Form/Reminders.js